import he from 'he';

/**
 * A function to take a REST API response and decode any encoded characters
 * in the rendered excerpt and title fields. Also supports arrays of posts.
 * @param {*} response - The parsed API response (after response.json()).
 * @returns {*} The decoded response.
 */
const decodeRestResponse = (response) => {
  // If the response isn't some type of object, return as-is.
  if ('object' !== typeof response) {
    return response;
  }

  // If the response is an array, process each item individually.
  if (Array.isArray(response)) {
    return response.map((item) => decodeRestResponse(item));
  }

  // We only care about decoding the "rendered" properties of excerpt and title, plus the "name" property.
  const {
    excerpt: {
      rendered: rawExcerpt = '',
    } = {},
    name: rawName = '',
    title: {
      rendered: rawTitle = '',
    } = {},
  } = response;

  // Conditionally replace excerpt.
  if (rawExcerpt) {
    response.excerpt.rendered = he.decode(rawExcerpt);
  }

  // Conditionally replace name.
  if (rawName) {
    response.name = he.decode(rawName);
  }

  // Conditionally replace title.
  if (rawTitle) {
    response.title.rendered = he.decode(rawTitle);
  }

  return response;
};

export default decodeRestResponse;
